<template>
  <div>
    <!-- stone-rebrand: Stone secure-env brand (rollout 100%, sem feature flag) -->
    <p class="emd-text stone-rebrand-footer eu-py_2">
      <a
        :href="secureEnvUrl"
        class="_type_outline _active stone-rebrand-footer__item"
        target="_blank"
        rel="noopener noreferrer"
      >
        <logo-stone-rebrand-icon class="stone-rebrand-footer-icon" />
        <span class="emd-text _color_default">Stone</span>
      </a>
      <span class="emd-text _color_nonessential">|</span>
      <span class="stone-rebrand-footer__item">
        <span class="emd-text _color_secondary">
          <i class="uil uil-shield-check" />
        </span>
        {{ $t('secureEnvironment') }}
      </span>
    </p>
    <emd-footer-internal
      :switchLanguage="switchLanguage"
      :switchThemeMode="switchThemeMode"
      :privacySecurity="privacySecurity"
      :help="help"
      :termsOfUse="termsOfUse"
      :privacyPolicy="privacyPolicy"
      :secureEnv="secureEnv"
      :documentation="documentation"
      :status="status"
      :listStyle="listStyle"
      @changeLanguage="changeLanguage"
      @changeThemeMode="changeThemeMode" />
  </div>
</template>
<script>
import { EmdFooterInternal } from 'emerald-vue/src/components'
import LogoStoneRebrandIcon from '@/components/emerald/atoms/LogoStoneRebrandIcon.vue'
export default {
  name: 'EmdFooter',
  data: () => ({
    darkMode: false
  }),
  components: {
    EmdFooterInternal,
    LogoStoneRebrandIcon
  },
  computed: {
    switchLanguage () {
      return {
        show: this.componentIsEnabled('footer', 'switchLanguage'),
        value: this.pref.language
      }
    },
    switchThemeMode () {
      return {
        show: this.componentIsEnabled('footer', 'switchThemeMode'),
        isDark: this.darkMode,
        position: 'relative',
        align: 'center'
      }
    },
    privacySecurity () {
      return {
        show: this.componentIsEnabled('footer', 'privacySecurity'),
        url: process.env.VUE_APP_URL_PRIVACY_SECURITY
      }
    },
    help () {
      return {
        show: this.componentIsEnabled('footer', 'help'),
        url: process.env.VUE_APP_URL_HELP
      }
    },
    secureEnv () {
      return {
        isLink: this.componentIsEnabled('footer', 'urlSite'),
        url: process.env.VUE_APP_URL_SITE,
        iconClass: 'emd-pagarme-icon-outline',
        icon: 'pagarme',
        // Always hidden: the Stone brand line renders instead (rollout 100%).
        show: false
      }
    },
    secureEnvUrl () {
      return process.env.VUE_APP_URL_SITE
    },
    termsOfUse () {
      return {
        show: this.componentIsEnabled('footer', 'termsOfUse'),
        url: process.env.VUE_APP_URL_TERMS_OF_USE,
        component: 'a'
      }
    },
    privacyPolicy () {
      return {
        show: this.componentIsEnabled('footer', 'privacyPolicy'),
        url: process.env.VUE_APP_URL_PRIVACY_POLICY
      }
    },
    documentation () {
      return {
        show: this.componentIsEnabled('footer', 'documentation'),
        url: process.env.VUE_APP_URL_DOCUMENTATION
      }
    },
    status () {
      return {
        show: this.componentIsEnabled('footer', 'status'),
        url: process.env.VUE_APP_URL_STATUS
      }
    },
    listStyle () {
      return {
        divide: true,
        footerClassList: ['eu-py_4 eu-mt_auto'],
        space: 'small',
        align: 'center'
      }
    },
    isPagarmeTheme () {
      return ['pagarme'].includes(process.env.VUE_APP_THEME)
    },
    pref () {
      return this.$store.getters.pref
    },
    theme () {
      return this.$store.getters.GET_THEME
    }
  },
  methods: {
    componentIsEnabled (section, component) {
      return this.$store.getters.componentIsEnabled(section, component)
    },
    changeLanguage (lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('SET_LANGUAGE', lang)
    },
    changeThemeMode (mode) {
      this.$store.dispatch('SET_NEW_THEME_MODE', mode)
    }
  },
  beforeMount () {
    if (this.pref.language) this.$i18n.locale = this.pref.language
    this.darkMode = this.pref.appearance.mode === 'dark'
  }
}
</script>

<i18n>
{
  "pt-BR": { "secureEnvironment": "Ambiente Seguro" },
  "en-US": { "secureEnvironment": "Secure Environment" }
}
</i18n>

<style scoped>
.stone-rebrand-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.stone-rebrand-footer__item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.stone-rebrand-footer-icon {
  width: 16px;
  height: 16px;
}
</style>
